import BlockyHeavyText from "components/custom-texts/blocky-heavy-text";
import sharedStyles from "assets/shared-stylesheets/contestant-list-item.module.css";
import styles from "./ordered-selection-entry-list-styles.module.css";
import entryItemStyles from "../entry-item-styles.module.css";
import { useRef } from "react";
import RankSelector from "./rank-selector";
import { formatWinPercent } from "utils/formatter-utils/win-percent-formatter";

interface Props {
  item: any;
  setHeight?: React.Dispatch<React.SetStateAction<number>>;
  numberOfSelections: number;
  onSelectContestantId: (contestantId: string, rank: number) => void;
  selectedContestantIds: string[];
  projectedWin: number;
  winOdds: number | undefined;
  winnerRank: number;
  isOpenPool: boolean;
  alreadyPicked?: boolean;
}

const OrderedSelectionEntryListItem = ({
                item,
                setHeight,
                numberOfSelections,
                onSelectContestantId,
                selectedContestantIds,
                projectedWin,
                winOdds,
                winnerRank,
                isOpenPool,
                alreadyPicked = false,
              }: Props) => {
  const ref = useRef(null);

  const isWinner = winnerRank <= numberOfSelections;

  let backgroundColor = "lightgray";
  let dividerColor = "gray";
  if (isOpenPool) {
    backgroundColor = "white";
    dividerColor = "lightgray"
  }

  return (
    <div
      id="div-Item-clickEntryItem"
      onClick={() => {
        setHeight && setHeight((ref.current as any)?.clientHeight);
      }}
    >
      <div
        style={{
          backgroundColor,
          border: isWinner ? "3px solid var(--winner-green)" : "",
          opacity: alreadyPicked ? 0.5 : 1,
          cursor: alreadyPicked ? "not-allowed" : undefined,
        }}
        ref={ref}
        className={`${sharedStyles.itemContainer} ${entryItemStyles.container}`}
        title={alreadyPicked ? "Already picked in this contest" : undefined}
      >
        <div className={`${sharedStyles.itemLeftColumnContainer} ${styles.orderedSelectionItemLeftColumnContainer}`}>
          <BlockyHeavyText
            className={entryItemStyles.titleText}
          >{`${item.name}`}</BlockyHeavyText>
          <div className={sharedStyles.inline}>
            <BlockyHeavyText className={`${sharedStyles.activeBetsText} ${entryItemStyles.labelText}`}>
              Projected Win:&nbsp;
            </BlockyHeavyText>
            <BlockyHeavyText className={entryItemStyles.oddsText}>
              {formatWinPercent(projectedWin)}
            </BlockyHeavyText>
          </div>
          <div className={sharedStyles.inline}>
            {winOdds !== undefined ? (
              <>
                <BlockyHeavyText className={entryItemStyles.labelText}>
                  Win Odds:&nbsp;
                </BlockyHeavyText>
                <BlockyHeavyText className={entryItemStyles.oddsText}>
                  {`${winOdds.toFixed(1)}x`}
                </BlockyHeavyText>
              </>
            ) : (
              <></>
            )}
          </div>
        </div>
          <div
            className={styles.orderedSelectionItemRightColumnContainer}
            style={{ borderLeft: `2px solid ${dividerColor}` }}
          >
            <RankSelector
              numberOfSelections={numberOfSelections}
              contestantId={item.id}
              onSelectContestantId={alreadyPicked ? () => {} : onSelectContestantId}
              selectedContestantIds={selectedContestantIds}
              winnerRank={winnerRank}
              isOpenPool={isOpenPool && !alreadyPicked}
            />
          </div>
      </div>
    </div>
  );
};

export default OrderedSelectionEntryListItem;
